import * as React from "react";

/**
 * Subscribes to a CSS media query. Use for behaviour that cannot be expressed
 * in Tailwind — swapping the sidebar for a drawer, for example. Pure styling
 * differences belong in responsive classes, not here.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );

  return React.useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    // Server snapshot — unused today (no SSR) but required by the API.
    () => false,
  );
}

/** The skill's mobile breakpoint: below 768px the sidebar becomes a drawer. */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767px)");
}
